import {
  CREATIVE_ID_OWNER_ACTIONS_APPROVED,
  CREATIVE_ID_OWNER_ACTIONS_DEACTIVATED,
  CREATIVE_ID_OWNER_ACTIONS_EXPIRED,
  CREATIVE_ID_OWNER_ACTIONS_EXPIRES,
  CREATIVE_ID_OWNER_ACTIONS_INCOMPLETE,
  CREATIVE_ID_OWNER_ACTIONS_NOT_APPROVED,
  CREATIVE_ID_OWNER_ACTIONS_PENDING_REVIEW,
} from 'client/site-modules/shared/constants/private-party/tracking';

export const LISTING_STATUS_PENDING_REVIEW = 'Pending';
export const LISTING_STATUS_REJECTED = 'Rejected';
export const LISTING_STATUS_APPROVED = 'Approved';
export const LISTING_STATUS_INACTIVE = 'Inactive';
export const LISTING_STATUS_EXPIRES = 'Expires';
export const LISTING_STATUS_EXPIRED = 'Expired';
export const LISTING_STATUS_AWAITING_PAYMENT = 'Awaiting Payment';
export const LISTING_STATUS_INCOMPLETE = 'Incomplete';
export const STATUS_DISPLAY_MAP = {
  [LISTING_STATUS_APPROVED]: 'Active',
  [LISTING_STATUS_PENDING_REVIEW]: 'Pending Approval',
  [LISTING_STATUS_REJECTED]: 'Deactivated',
  [LISTING_STATUS_INACTIVE]: 'Deactivated',
};

export const STATUS_TRACKING_ID_MAP = {
  [LISTING_STATUS_APPROVED]: CREATIVE_ID_OWNER_ACTIONS_APPROVED,
  [LISTING_STATUS_REJECTED]: CREATIVE_ID_OWNER_ACTIONS_NOT_APPROVED,
  [LISTING_STATUS_PENDING_REVIEW]: CREATIVE_ID_OWNER_ACTIONS_PENDING_REVIEW,
  [LISTING_STATUS_EXPIRES]: CREATIVE_ID_OWNER_ACTIONS_EXPIRES,
  [LISTING_STATUS_EXPIRED]: CREATIVE_ID_OWNER_ACTIONS_EXPIRED,
  [LISTING_STATUS_INACTIVE]: CREATIVE_ID_OWNER_ACTIONS_DEACTIVATED,
  [LISTING_STATUS_INCOMPLETE]: CREATIVE_ID_OWNER_ACTIONS_INCOMPLETE,
};

export const MAX_TRUNCATED_SELLER_COMMENTS_CHAR_LIMIT = 440;

export const DEACTIVATE_OPTION = 'Deactivate My Listing';
export const SUPPORT_OPTION = 'Get Support';

export const CARD_CONFIG = {
  [LISTING_STATUS_APPROVED]: {
    labelClass: 'approved size-14 fw-medium px-0_5 py-0_25 rounded bg-green-50',
    showEditButton: true,
    showRenewButton: false,
    showActivateButton: false,
    editCta: 'Edit Listing',
    options: [DEACTIVATE_OPTION, SUPPORT_OPTION],
  },
  [LISTING_STATUS_PENDING_REVIEW]: {
    labelClass: 'pending-review fw-medium bg-turquoise-20 px-0_5 py-0_25 rounded size-14',
    showEditButton: true,
    showRenewButton: false,
    showActivateButton: false,
    editCta: 'Edit Listing',
    options: [DEACTIVATE_OPTION, SUPPORT_OPTION],
  },
  [LISTING_STATUS_REJECTED]: {
    labelClass: 'rejected fw-medium bg-orange-10 px-0_5 py-0_25 rounded size-14',
    showEditButton: true,
    showRenewButton: false,
    showActivateButton: false,
    editCta: 'Edit & Resubmit',
    options: [DEACTIVATE_OPTION, SUPPORT_OPTION],
  },
  [LISTING_STATUS_EXPIRES]: {
    labelClass: 'expires size-14 fw-medium px-0_5 py-0_25 rounded bg-orange-10',
    showEditButton: true,
    showRenewButton: true,
    showActivateButton: false,
    editCta: 'Edit Listing',
    renewCta: 'Renew Listing',
    options: [DEACTIVATE_OPTION, SUPPORT_OPTION],
  },
  [LISTING_STATUS_EXPIRED]: {
    labelClass: 'expired size-24 fw-medium text-center w-100 center-xy',
    showEditButton: false,
    showRenewButton: true,
    showActivateButton: false,
    renewCta: 'Renew Listing',
    options: [SUPPORT_OPTION],
  },
  [LISTING_STATUS_INACTIVE]: {
    labelClass: 'inactive size-24 fw-medium w-100 text-center center-xy',
    showEditButton: false,
    showRenewButton: false,
    showActivateButton: true,
    activateCta: 'Activate Listing',
    options: [SUPPORT_OPTION],
  },
  [LISTING_STATUS_INCOMPLETE]: {
    showPublishBtn: true,
    publishCta: 'Finish Checkout & Publish',
    options: [SUPPORT_OPTION],
  },
};

export const RENEWED_LISTING_SESSION_KEY = 'renewedListing';

export const RENEW_CONFIRMATION_MODAL_DATA = {
  [LISTING_STATUS_EXPIRED]: {
    header: 'Renewal Completed!',
    subheader: 'Thank you for renewing!',
    actionItems: [
      { title: 'Payment', description: 'You won’t be charged until your listing is active.' },
      { title: 'Processing Time', description: 'Expect 1–2 business days to go live.' },
      { title: 'Notifications', description: "We'll email you when your listing is published." },
    ],
  },
  [LISTING_STATUS_EXPIRES]: {
    header: 'Listing Renewal Complete',
    subheader: 'Thank you for your payment!',
  },
};
